module.exports = __webpack_public_path__ + "img/Gasmachine2.61c1a684.png";